import React from "react";
import { string, func, array } from "prop-types";
import { Radio } from "antd";
const CoreDataMode = ({ selectedMode, options, onClick }) => {
  function onChange(event) {
    onClick(event.target.value);
  }

  return (
    <Radio.Group onChange={onChange} defaultValue={selectedMode} size="medium">
      {options.map(opt => (
        <Radio.Button key={opt.value} value={opt.value}>
          {opt.text} data
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};

CoreDataMode.propTypes = {
  selectedMode: string.isRequired,
  options: array.isRequired,
  onClick: func.isRequired
};

export default CoreDataMode;



// WEBPACK FOOTER //
// ./src/views/core/core_data_mode/CoreDataMode.jsx